import { getBalancedGridColumnCount } from "@templates/design-system";
import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { LogoCloudItem } from "../LogoCloudItem/LogoCloudItem";
import type { ILogoCloudGridProps } from "./LogoCloudGrid.props";

export const LogoCloudGrid = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  spacing,
}: ILogoCloudGridProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);
  const actions = buttons ?? [];
  const hasActions = actions.length > 0;
  const hasIntroContent = hasCommonContent || hasActions;
  const desktopColumnCount = getBalancedGridColumnCount(items.length);

  return (
    <BlockContainer anchorId={anchorId} spacing={spacing}>
      {hasCommonContent ? (
        <BlockCommonContent
          alignment={alignment}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingLevel="h2"
        />
      ) : null}
      {hasActions ? (
        <BlockActions
          actions={actions}
          alignment={alignment}
          className={hasCommonContent ? "mt-8" : undefined}
        />
      ) : null}
      <ResponsiveBlockGrid
        className={hasIntroContent ? "mt-12 gap-x-8 gap-y-5 md:mt-16" : "gap-x-8 gap-y-5"}
        columnCount={desktopColumnCount}
        role="list"
      >
        {items.map((item, index) => (
          <ResponsiveBlockGridItem key={`${item.logo.defaultSrc}-${index}`} role="listitem">
            <LogoCloudItem {...item} />
          </ResponsiveBlockGridItem>
        ))}
      </ResponsiveBlockGrid>
    </BlockContainer>
  );
};

LogoCloudGrid.displayName = "LogoCloud::LogoCloudGrid";
